import styled from "styled-components"
import {Col} from "@malwarebytes/react-components/build"

export const ColRight = styled(Col)`
    text-align: right;
`
